<template>
    <v-container>
        <v-container fluid>
            <v-row align="start" justify="center">
                <span>
                    <h1>Estamos a tus órdenes</h1>
                </span>
            </v-row>
            <v-row>
                <v-col cols="12" md="6" sm="12" xs="12">
                    <v-row>
                        <p class="display-1">
                            Estamos ubicados en:
                        </p>
                    </v-row>
                    <v-row>
                        <p class="font-weight-black">
                            Genaro Padilla 140, Col centro pitillal, Puerto Vallarta, Jalisco
                        </p>
                    </v-row>
                    <v-row>
                        <p>
                            Al Correo electronico:
                        </p>
                    </v-row>
                    <v-row>
                        <p>
                            info@wallaudit.com
                        </p>
                    </v-row>
                    <v-row> 
                        <v-form>
                            <v-text-field label="Email" ref="correo" type="email" v-model="form.correo" :error-messages="getErrors('correo')">
                            </v-text-field>
                            <v-textarea label="Ingrese aqui sus intereses, nuestros agentes lo contactaran" ref="mensaje" v-model="form.mensaje" :error-messages="getErrors('mensaje')">
                            </v-textarea>
                            <v-checkbox label="Deseo recibir todas las actualizaciones de nuestro blog" v-model="form.ofertas">
                            </v-checkbox>
                            <v-btn @click="enviarCorreo">
                            <span>Enviar</span>
                            </v-btn>
                        </v-form>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6" sm="12" xs="12">
                    <mapita></mapita>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>


<script>
import axios from 'axios'
import mapita from '@/components/mapa'
import { validationMixin } from 'vuelidate'
  import {
    required,
    email
  } from 'vuelidate/lib/validators'
export default {
    mixins: [validationMixin],
    data: () => ({
        form: {
            correo: '',
            mensaje: "",
            ofertas: true,
        }
    }),
    
    validations: {
        form:{
            correo:{
                required,
                email
            },
            mensaje: {
                required
            }
        }
    },
    methods: {
        getErrors (fieldName){
            const field = this.$v.form[fieldName]
            if (field) {
                const errors =[]
                if(!field.$dirty) return errors
                !field.required && errors.push("Se requiere este campo")
                !field.email && errors.push("El correo es incorrecto")
                return errors
            }
        },

        async enviarCorreo(){
            this.$v.$touch()
            if(!this.$v.$invalid){
                var peticion = await axios.post('https://wallaudit.com/api2/create.php',"correo=" + this.form.correo +"&cuerpo="+this.form.mensaje+"&suscripcion="+this.form.ofertas)
                if(peticion.data.mensaje=="Correo enviado"){
                    this.form.correo=""
                    this.form.mensaje= ""
                    this.form.ofertas= true
                    alert("Se envio el correo")
                }else{
                    alert("Error al enviar el correo")
                }
            }else{
                alert("Por favor verifique los datos")
            }
        }
    },
    components:{
        mapita
    }
}
</script>

<style>

</style>